module.exports = "::ng-deep datatable-header{\n  width: auto !important;\n}\n\n::ng-deep datatable-body{\n  width: auto !important;\n}\n"